<div class="alert alert-danger text-center mt-25" [hidden]="!error">Oops! Something went wrong!</div>
